module.exports = "/fast-coin/img/coin/anim/out_1/out_1_003.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_1/out_1_003.png
// module id = 2299
// module chunks = 5